<template>
  <div>
    <search-area tabName="订单列表" @search="search(1)">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="订单号" prop="name" :label-width="105">
          <Input
            v-model="searchParam.orderNum"
            placeholder="请输入订单编号"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="订单状态" prop="name" :label-width="105">
          <Select
            v-model="searchParam.state"
            style="width: 160px"
            @on-change="search(1)"
            clearable
          >
            <Option
              v-for="item in stateList"
              :value="item.code"
              :key="item.code"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="orderList"
      :total="total"
      @search="search"
      :pageNum="searchParam.currentPage"
      :pageSize="searchParam.pageSize"
    ></table-area>
  </div>
</template>
<script>
import columns from "./column-config";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 1,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        orderNum: "", //订单号
        state: "", // 订单状态
        currentPage: 1,
        pageSize: 10,
      },
      orderList: [],
      stateList: [
        //0订单取消 1待付款 2待预约 3服务中 4已完成 10退款成功
        { code: 1, value: "待付款" },
        { code: 2, value: "待预约" },
        { code: 3, value: "服务中" },
        { code: 4, value: "已完成" },
      ],
    };
  },
  computed: {},
  created() {
    this.getOrderList();
  },
  methods: {
    // 执行搜索
    search(val) {
      this.searchParam.currentPage = val;
      this.getOrderList();
    },
    async getOrderList() {
      let { list, total } = await this.$post(
        "/order/listByPage",
        this.searchParam
      );
      list = list || [];
      //  0订单取消 1待付款 2待预约 3服务中 4已完成 5待保洁员处理 6-预约成功待派单 7-派单成功未开始服务 8-开始服务
      list.forEach((_order) => {
        if (_order.orderProductBoList.length == 1) {
          // 订单只有一个商品
          _order.state = _order.orderProductBoList[0].state;
          if (_order.state == 3) {
            // 服务中 判断 订单是否派单成功 是否开始服务
            let { cleanerId, state } =
              _order.orderProductBoList[0].cleanerServiceLogList[
                _order.orderProductBoList[0].cleanerServiceLogList.length - 1
              ];
            _order.state =
              state == 1 ? (cleanerId ? 7 : 6) : state == 2 ? 8 : 4;
          }
        } else {
          // 多商品 存在一个待预约即是待预约
        }
      });
      this.orderList = list || [];
      this.total = total || 0;
    },
    // 管理员取消订单
    handleCancelOrder(orderId, orderNum) {
      this.$confirm(`确认取消订单 ${orderNum}？此操作不可撤销。`, "取消订单", {
        confirmButtonText: "确定取消",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 调用取消订单 API
          await this.$post("/order/adminCancel", { orderId });
          this.$message({ type: "success", message: "订单已取消" });
          this.getOrderList();
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消操作" });
        });
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'

.tableOut
    height: 50px;
    border: 0.1px solid #e0dede;
    background: #f1f4f512;
    span
      width: 20%;
      text-align: center;
      display: inline-block;
      float: left;
      font-size: 17px;
      border-right: 1px solid #e0dede;
      height: 50px;
      line-height: 50px;
      box-sizing: border-box;

.huiline
    padding:10px;
    border: 1px solid #e0dede;
    box-sizing: border-box;
    width: 100%;
    border-top: 0;
    background: #f1f4f512;
    font-size: 13px;
    color: #b3b0b0;

    span
     margin-left 40px
.payitem
    display: flex;
    flex-direction: column;
    text-align: left;
    box-sizing: border-box;
    padding-left: 50px;

.details
    display: flex;
    justify-content: space-around;
    font-size: 13px;
    border-bottom: 1px solid #e0dede;
    border-right: 1px solid #e0dede;

  .divspp
    width:20%;
    border-left: 1px solid #e0dede;
    padding: 10px 0;
    box-sizing:border-box;
    display: flex;
    flex-direction: column;
    align-items:center;
    text-align: left;
    box-sizing: border-box;
    justify-content: center;
.picker
    margin-left 10px

.filter-search
  display flex
  flex-wrap wrap

  .el-date-editor
    max-width 360px
    margin-right 10px
    margin-bottom 10px

  .el-input
    max-width 140px
    margin-right 10px
    margin-bottom 10px

.option-button
  position relative
  padding-right 50px

  .edit-btn
    position absolute
    right 4px

.form-upload-excel
  display inline-block
  margin-left 10px

.table-container
  margin-top 20px

  .el-pagination
    margin-top 20px

  .preview
    display flex
    justify-content center
    align-items center
    padding 10px
    margin-top 6px
    border 1px dashed #999
    border-radius 6px
  .el-dialog
    width: 500px;
.Dealing{
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100px;
}
.wildFinished{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  .DealFinished{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: normal;
    width: 200px;
  }
  .DealFinishedfoot{
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
.direct-mail{
  color: #7600FF;
  border: 1px solid #7600FF;
  padding: 2px;
  margin-right: 2px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
